import UserLink, { Props as UserLinkProps } from './UserLink';

export type { UserLinkProps };
export default UserLink;
